export default __webpack_public_path__ + "static/media/p3.f4175242.png";